export enum Events {
  SaveQuoteForm = "FormSent",
  ResponseSaveQuoteForm = "FormCompleted",
  GetQuoteFormById = "FormById",
  ResponseGetQuoteFormById = "FormAnswerById",
  RequoteForm = "ReQuoteForm",
  OfferSelected = "OfferSelected",
  GetOfferById = "OfferByIdSent",
  ResponseGetOfferById = "OfferById"
}
